import { useSections } from "@/contexts/classified";
import { addSources, buildMasonryArray, getOriginIndex } from "@/gallery/utils";
export const useImages = () => {
    var _a, _b, _c;
    const images = (_c = (_b = (_a = useSections()) === null || _a === void 0 ? void 0 : _a.gallery) === null || _b === void 0 ? void 0 : _b.images) !== null && _c !== void 0 ? _c : [];
    return {
        imagesCount: images.length,
        imagesFullscreen: images.map(addSources("fullscreen")).map(getOriginIndex),
        masonryImages: buildMasonryArray(images),
    };
};
